@if (label || helpText) {
  <div class="mb-2 flex items-center gap-1">
    @if (label) {
      <mat-label class="text-sm font-medium">{{ label }}</mat-label>
    }
    @if (helpText) {
      <mat-icon
        class="material-icons-outlined hvs-icon-base cursor-help"
        [matTooltip]="helpText"
        matTooltipPosition="above"
        matTooltipClass="tooltip-above"
      >
        help_outline
      </mat-icon>
    }
  </div>
}
<mat-form-field
  *transloco="let t"
  class="select__form_field size-full"
  appearance="outline"
  [id]="id"
  [subscriptSizing]="bottomMargin ? 'fixed' : 'dynamic'"
>
  @if (icon) {
    <mat-icon matPrefix class="mr-2 text-base">{{ icon }}</mat-icon>
  }
  <mat-select [formControl]="control" [placeholder]="placeholder">
    @for (option of options; track option.value) {
      <div
        [matTooltip]="(option.disabled && lockReason) || ''"
        [matTooltipDisabled]="!option.disabled || !lockReason"
      >
        @if (translocoPrefix) {
          <mat-option [value]="option.value" [disabled]="option.disabled">
            <div class="flex w-full items-center justify-between">
              <span>{{ getLabel(option.key) }}</span>
              @if (option.disabled) {
                <mat-icon class="material-icons-outlined hvs-icon-lg ml-2">
                  lock
                </mat-icon>
              }
            </div>
          </mat-option>
        } @else {
          <mat-option [value]="option.value" [disabled]="option.disabled">
            <div class="flex w-full items-center justify-between">
              <span>{{ option.key }}</span>
              @if (option.disabled) {
                <mat-icon class="material-icons-outlined hvs-icon-lg ml-2">
                  lock
                </mat-icon>
              }
            </div>
          </mat-option>
        }
      </div>
    }
  </mat-select>
  <mat-icon matSuffix>expand_more</mat-icon>
  @if (control.invalid && errorMessage()) {
    <mat-error class="text-sm">
      {{ t('general.inputValidation.' + errorMessage()) }}
    </mat-error>
  }
</mat-form-field>
